export type RowData = {
  key: string;
  type?: string;
  guest?: string;
};

export const PRICE_TYPES = ['Night stay', 'Daytime'] as const;
export const GUEST_TYPES = ['Adult', 'Child'] as const;

export type PriceType = (typeof PRICE_TYPES)[number];
export type GuestType = (typeof GUEST_TYPES)[number];
